import { render } from "./FaceAnimationAndQR.vue?vue&type=template&id=362c62bc"
import script from "./FaceAnimationAndQR.vue?vue&type=script&lang=js"
export * from "./FaceAnimationAndQR.vue?vue&type=script&lang=js"

import "./FaceAnimationAndQR.vue?vue&type=style&index=0&id=362c62bc&lang=scss"
script.render = render

export default script